<template></template>

<script>
// @ is an alias to /src
import { _mountedfun } from "../views/utils/tools.js";

// 落地页
export default {
  name: "Home",
  mounted() {
    _mountedfun(this, true)
  },
  methods: {
    
  },
};
</script>
